import(/* webpackMode: "eager" */ "/codebuild/output/src629848468/src/apps/fanychance/src/assets/images/status/status-label-end.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src629848468/src/apps/fanychance/src/assets/images/status/status-label-hold.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src629848468/src/apps/fanychance/src/assets/images/status/status-label-notice.png");
;
import(/* webpackMode: "eager", webpackExports: ["default","faClock","faTruck"] */ "/codebuild/output/src629848468/src/apps/fanychance/src/components/icon/FaIcon/FaIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src629848468/src/apps/fanychance/src/components/ui/UrlShare/UrlShare.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src629848468/src/apps/fanychance/src/features/lottery/components/LotteryDetailDescription/LotteryDetailDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src629848468/src/apps/fanychance/src/features/lottery/components/LotteryGoodsModal/LotteryGoodsModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src629848468/src/apps/fanychance/src/features/lottery/components/LotteryPrizeList/LotteryPrizeList.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src629848468/src/apps/fanychance/src/features/lottery/components/ShippingAlert/ShippingAlert.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src629848468/src/apps/fanychance/src/features/lottery/components/LotteryDetailHeader/LotteryDetailHeader.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src629848468/src/apps/fanychance/src/features/lottery/components/LotteryTagList/LotteryTagList.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src629848468/src/apps/fanychance/src/features/lottery/components/SpecialInduction/SpecialInduction.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src629848468/src/apps/fanychance/src/features/serialCode/components/SerialCodeFab/SerialCodeFab.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src629848468/src/node_modules/next/dist/client/link.js");
